var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "520.000000pt",
    height: "435.000000pt",
    viewBox: "0 0 520.000000 435.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,435.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3424 c0 -512 3 -1492 7 -2178 l6 -1248 967 967 967 967 323 -331 c178 -182 326 -331 330 -331 3 0 158 149 343 331 l336 330 424 -428 c232 -235 660 -669 950 -963 290 -294 532 -536 537 -538 7 -2 10 776 10 2154 l0 2159 -102 -101 c-548 -536 -1343 -1318 -1556 -1528 l-262 -261 -334 334 -335 334 -78 -71 c-43 -39 -195 -188 -338 -331 l-260 -261 -625 622 c-344 343 -779 776 -967 963 l-343 340 0 -931z m1023 -1901 c-360 -365 -657 -663 -659 -663 -2 0 -4 595 -4 1322 l0 1323 659 -659 660 -660 -656 -663z m3824 114 l-2 -778 -652 663 -653 663 648 650 647 650 7 -535 c4 -294 7 -885 5 -1313z m-2037 742 c160 -174 190 -213 179 -223 -8 -7 -100 -96 -205 -199 l-190 -187 -156 158 c-85 86 -175 179 -198 205 l-44 48 205 205 c112 112 207 204 210 204 4 0 93 -95 199 -211z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f9ec9b2423537d6e4cacb8a3fad5157.svg";
export { ForwardRef as ReactComponent };